import CONFIRM_DIALOGS from './confirm-dialog/en';
import ERROR_DIALOGS from "./error-dialog/en";
import RESULT_DIALOGS from "./result-dialog/en";
import AGENCY_SETTINGS from './agency-settings/en';

export default {
    BUTTONS: {
        SUBMIT: "Verzenden",
        PREVIOUS: "Vorige",
        NEXT: "Volgende",
        VIEW: "Bekijken",
        UPLOAD: "Uploaden",
        UPLOAD_FILE: "Bestand uploaden",
        VIEW_FILE: "Bestand bekijken",
        DELETE_FILE: "Bestand verwijderen",
        CLOSE: "Sluiten",
        DELETE: "Verwijderen",
        CANCEL: "Annuleren",
        YES: "Ja",
        NO: "Nee",
        OK: "Ok",
        ADD: "Toevoegen",
        UPDATE_STATUS: "Status bijwerken",
        RETURN_DASHBOARD: "Terug naar dashboard",
        REFRESH: "Vernieuwen",
        BULK_UPDATE_STATUS: "Update status van geselecteerd",
        BULK_OVERWRITE_LOCATIONS: "Locaties overschrijven",
        BULK_OVERWRITE_TYPES: "Typen overschrijven",
        BULK_OVERWRITE_TAGS: "Tags overschrijven",
        BULK_ADD_LOCATIONS: "Locaties toevoegen",
        BULK_ADD_TYPES: "Typen toevoegen",
        BULK_ADD_TAGS: "Tags toevoegen",
        BULK_UPDATE: "Bulk-update",
        CHARGE_THROUGH_AUTHORIZE_NET: "Opladen via Authorize.Net",
        CHARGE_THROUGH_STRIPE: "Opladen via streep",
        INVOICE_THROUGH_STRIPE: "Factuur via streep",
        CHARGE_CLIENT_AND_PAYOUT_CANDIDATE: "Klant en uitbetalingskandidaat in rekening brengen",
        BULK_COPY_SUGGESTED_CHARGE: "Voorgestelde kosten voor bulkkopie naar totale klantkosten",
        BULK_DELETE: "Geselecteerde verwijderen",
        BULK_UNASSIGNED: "Toewijzing selectie ongedaan maken",
        EXPORT_EMPLOYERS: "Exporteer mailinglijst voor klanten",
        EXPORT_CANDIDATES: "Mailinglijst van kandidaten exporteren",
        UPDATE_MANAGER: "Update {0} Manager",
        VIEW_PROFILE: "Bekijk profiel",
        VIEW_OFFER: "Bekijk aanbieding",
        SAVE: "Opslaan",
        EXPAND_ALL: "Alles uitvouwen",
        COLLAPSE_ALL: "Alles samenvouwen",
        SELECT_ALL: "Alles selecteren",
        UNSELECT_ALL: "Alles deselecteren",
        RESET_FILTERS: "Filters resetten",
        CLOCK_IN: "Inklokken",
        ADD_A_BREAK: "Voeg een pauze toe",
        CLOCK_OUT: "Uitklokken",
        CONFIRM_CLOCK_IN_OUT: "Klant bevestigen",
        LEAVE_REVIEW: "Laat een recensie achter",
        DECLINE: "Weigeren",
        DECLINE_WITHOUT_NOTIFICATION: "Weigeren zonder kennisgeving",
        UNDECLINE: "Ongedaan maken",
        ACCEPT: "Accepteren",
        CHECK_PAYMENT: "Betalingsuitdrukking controleren",
        ASSIGN: "Toewijzen",
        TENTATIVELY_ASSIGN: "Voorlopig toewijzen",
        SIGN: "Teken",
        EDIT: "Bewerken",
        DUPLICATE: "Dupliceren",
        ADD_A_BOOKING: "Voeg een boeking toe",
        ADD_A_GROUP: "Een groep toevoegen",
        MESSAGE: "Bericht",
        UPDATE_CUSTOM_STATUS: "Update {0}-status",
        UPDATE: "Bijwerken",
        ADD_OPTION: "Optie toevoegen",
        EDIT_SETTING: "Instellingen bewerken",
        DONE: "Gereed"
    },
    PLACE_HOLDERS: {
        NEW_STATUS: "Nieuwe status",
        NEW_LOCATIONS: "Nieuwe locaties",
        NEW_TYPES: "Nieuwe typen",
        NEW_TAGS: "Nieuwe tags",
        FILTER_BY_STATUS: "Filteren op status",
        FILTER_BY_STATUSES: "Filteren op status",
        STATUSES_TO_HIDE: "Statussen om te verbergen",
        FILTER_BY_LOCATIONS: "Filteren op locaties",
        FILTER_BY_TYPES: "Filteren op type",
        FILTER_BY_TAGS: "Filteren op tags",
        FILTER_BY_MANAGER: "Filteren op beheerder",
        FILTER_BY_CATEGORIES: "Filteren op categorieën",
        FILTER_BY_START_DATE: "Filteren op startdatum",
        FILTER_BY_END_DATE: "Filteren op einddatum",
        FILTER_BY_WEEK_DAY: "Filteren op weekdag",
        FILTER_BY_CLIENTS: "Filteren op klanten",
        FILTER_BY_CLIENT_STATUSES: "Filteren op klantstatus",
        FILTER_BY_CLIENT_TYPES: "Filteren op clienttypes",
        FILTER_BY_CANDIDATES: "Filter op kandidaat(s)",
        FILTER_BY_JOB_TYPES: "Filter op taaktype",
        FILTER_BY_JOB_STATUSES: "Filteren op taakstatus",
        FILTER_BY_JOB_ID: "Filteren op taak-ID",
        SELECT_SCRAPER_ACCOUNTS: "Selecteer Scraper-accounts",
        FILTER_BY_USER_TYPE: "Filteren op gebruikerstype",
        KEYWORD_SEARCH_USER_PROFILE: "Zoek naar trefwoord/zin ergens in het gebruikersprofiel, druk op Enter om de zoekopdracht toe te passen",
        SEARCH_BY_NAME_EMAIL_PHONE: "Zoeken op naam, e-mail of telefoonnummer",
        FILTER_BY_RECENT_ACTIVE: "Filteren op recent actief",
        SELECT_LOCATIONS: "Selecteer locaties",
        SELECT_OPTION: "Selecteer optie",
        SELECT_CLIENT: "Klant selecteren",
        SELECT_CANDIDATE: "Kandidaat selecteren",
        SELECT_CANDIDATES: "Kandidaten selecteren",
        SELECT_CANDIDATE_SEARCHABLE: "Selecteer kandidaat (type om te zoeken)",
        SELECT_ADMINS: "Selecteer beheerders",
        SELECT_ADMIN_RECEIVE_EMAIL: "Selecteer beheerders die e-mails ontvangen",
        SELECT_STATUS: "Selecteer status",
        SELECT_LANGUAGES: "Selecteer talen",
        SELECT_TYPES: "Selecteer typen",
        SELECT_TYPE: "Selecteer Type",
        SELECT_TAGS: "Selecteer tags",
        SELECT_USER_TYPE: "Selecteer gebruikerstype",
        SELECT_USER_TYPES: "Selecteer gebruikerstypes",
        SELECT_CATEGORY: "Selecteer categorie",
        SELECT_CATEGORY_ADMIN_ONLY: "Selecteer categorie (alleen beheerder)",
        SELECT_TRIGGER: "Selecteer trigger",
        SELECT_ONE: "Kies er een",
        SELECT_PROFILE_BUILDER: "Selecteer profielbouwer",
        SELECT_TIME_OFF_CATEOGRY: "Selecteer vrije tijd categorie",
        SELECT_DESTINATION: "Selecteer bestemming",
        SELECT_ACCESS_LEVEL: "Selecteer toegangsniveau",
        SELECT_VISIBILITY_SCOPE: "Selecteer zichtbaarheidsbereik",
        SELECT_AREAS: "Selecteer gebieden",
        NUMBER: "Nummer",
        DESCRIPTION_CHARGE: "Beschrijving van kosten",
    },
    LABELS: {
        SELECT_TEMPLATE: "Sjabloon selecteren",
        SELECT_ANALYTICS_DASHBOARD_FIELDS: "Selecteer velden voor analyse",
        FILTER_BY_LOCATIONS: "Filteren op locaties",
        FILTER_BY_TYPES: "Filteren op type",
        FILTER_BY_MANAGER: "Filteren op beheerder",
        FILTER_BY_CATEGORIES: "Filteren op categorieën",
        FILTER_BY_STATUS: "Filteren op status",
        ADDRESS: "Adres",
        CITY: "Stad",
        STATE: "Staat",
        COUNTRY: "Land",
        ZIP_CODE: "Postcode",
        LOCATIONS: "Locaties",
        DESCRIPTION: "Beschrijving",
        PER_HOUR: "per uur",
        ADD_ITEM: "Voeg {0} toe",
        EDIT_ITEM: "Bewerken {0}",
        SAVE_AND_ADD_ANOTHER_ITEM: "Opslaan en nog een {0} toevoegen",
        WELCOME_TEXT: "Welkom bij {0}"
    },
    HEADERS: {
        EMAIL_LOG: "E-maillogboek",
        SMS_LOG: "SMS-logboek"
    },
    LINK_TEXT: {
        HIDE_STATUS_BY_DEFAULT: "Hoe statussen standaard te verbergen",
        HOW_TO_CHANGE_STATUS: "Hoe statussen toevoegen/wijzigen"
    },
    DESCRIPTIONS: {
        SEPARATE_MULTIPLE_EMAIL: "Scheid meerdere e-mails met ; (bijv.: nanny1@hotmail.com; nanny2@hotmail.com )",
        SMS_NOTE: `Houd er rekening mee dat er een prijs van $ 0,0115 (1,15 ) per 160 tekens verzonden/ontvangen SMS is.`,
        SMS_COUNTER_NOTE: `Het exacte aantal tekens hangt af van de informatie die in het eigenlijke bericht is ingevoegd.`,
        CLIENT_NOT_ENTERED_STRIPE: "Klant heeft geen Stripe-informatie ingevoerd.",
        CLIENT_NOT_ENTERED_AUTHORIZE_NET: "Klant heeft geen Authorize.Net-informatie ingevoerd.",
        CANDIDATE_NOT_ENTERED_STRIPE: "Kandidaat heeft geen Stripe-informatie ingevoerd.",
        INTERVIEW_PANEL: `Opmerking: deze opmerkingen zijn alleen voor intern beheerdersgebruik en zijn dat niet
        gedeeld met kandidaten of opdrachtgevers.`,
        CANDIDATE_SHAREABLE_LINK: `Dit is een deelbare link van het kandidatenprofiel. Als je wil
        om te zien wat een klant te zien krijgt, <strong>zorg ervoor dat u uitlogt</strong> en dan
        bekijk de link (of open deze in een andere browser). Dit is <strong>geen</strong> een link waarmee uw kandidaat kan inloggen. <a href="https://youtu.be/WXjyLdF12O0" target="_blank">Meer informatie.</a>`,
        CLIENT_SHAREABLE_LINK: `Dit is een deelbare link van het klantprofiel. Als je wilt
        zie wat een kandidaat te zien krijgt, <strong>zorg ervoor dat je uitlogt</strong> en dan
        bekijk de link (of open deze in een andere browser). Dit is <strong>geen</strong> een link waarmee uw klanten kunnen inloggen. <a href="https://youtu.be/WXjyLdF12O0" target="_blank">Meer informatie.</a>`,
        CLIENT_PUBLIC_PAYMENT_LINK: `Dit is een openbare betalingslink. Klant heeft toegang tot deze link om betalingsinformatie in te voeren zonder in te loggen`,
        TYPE_YOUR_NAME_TO_SIGN: 'Typ uw naam om te ondertekenen (u gaat ermee akkoord dat dit het equivalent is van het ondertekenen van een fysiek document)'
    },
    TABLE_HEADERS: {
        ACTIES: "Acties",
        NOTES: "Opmerkingen",
        VALUE: "Waarde",
        EFFECTIEF_FROM: "Effectief vanaf",
        EFFECTIVE_UNTIL: "Effectief tot",
        TYPE: "Type"
    },
    OPTIONS: {
        "JA": "Ja",
        "NEE": "Nee"
    },
    ERROR_MESSAGES: {
        FIELD_REQUIRED: "Dit veld is verplicht."
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "Bedankt!",
        STEP_OF: "Stap {0} van {1}"
    },
    REFERENCE_CHECK_FORM: {
        FILL_THE_FORM_REQUEST: "Help ons het onderstaande formulier in te vullen",
        REFERENCE_FOR: "Referentie voor {0} {1}",
        REFERENCE_INPUT_BY: "Referentie-informatie ingevoerd door {0} {1}",
        FORM_SUBMITTED: "Het referentiecontroleformulier is verzonden!"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Slaat hier een bestand neer of klik om te uploaden",
        MAXIMUM_UPLOAD_SIZE: "Maximale uploadgrootte {0}MB",
        FILE_EXCEED_MAXIMUM: "Bestandsgrootte is groter dan {0}MB.",
        FILE: "Bestand"
    },
    BOOKING_SECTION: {
        LABEL: {
            BOOKINGS: "Boekingen",
            HIDE_PAST_BOOKINGS: "Verberg eerdere boekingen",
            BOOKING_CREDIT_LEFT: "{0} boekingstegoed over",
            MIN_BOOKINGS_REQUIRE: "Je hebt minimaal {0} boekingen nodig!",
            SELECTED_CANDIDATE: "Geselecteerde kandidaat",
            TOTAL_BOOKING_FEE: "Totale boekingskosten",
            BOOKING_GROUPS: "Boekingsgroepen"
        },
        DESCRIPTION: {
            CLICK_ON_BOOKING: "Klik op de boeking (in de kalender) om meer te weten te komen over de aan u toegewezen serviceprovider en om een ​​beoordeling achter te laten.",
            CLICK_ON_DATE: "Klik op een datum om een ​​boeking toe te voegen.",
            CLICK_ON_OTHER_DATE: "Klik op een andere datum in de kalender om een ​​boeking toe te voegen.",
            BOOKING_GROUP: "Alle boekingen in dezelfde groep moeten aan één toegewezen persoon worden toegewezen"
        },
        PRICES: {
            BOOKING_RATE: "Reserveringstarief",
            BOOKING_FEE: "Boekingskosten",
            PER_BOOKING_FEE: "Per boekingskosten",
            CLIENT_RATE: "Klantpercentage",
            CANDIDATE_RATE: "Kandidaattarief",
            AGENCY_FEE: "Bureaukosten",
            TRAVEL_FEE: "Reiskosten",
            RUSH_FEE: "Spoedkosten",
            CANDIDATE_RUSH_FEE: "Kandidaat Rush Fee",
            PER_BOOKING_AGENCY_FEE: "Vergoeding per boekingsbureau",
            PER_BOOKING_CANDIDATE_FEE: "Per boekingskandidaatvergoeding",
            ADMIN_FEE: "Administratieve kosten",
            ADDITIONAL_FEES: "Extra kosten"
        }
    },
    BOOKING_DIALOG: {
        LABEL: {
            ADDITIONAL_DATES: "Extra datums toevoegen",
            START_TIME: "Begintijd",
            END_TIME: "Eindtijd",
            END_DATE: "Einddatum",
            SELECT_CLIENT: "Klant selecteren",
            ASSIGNED_CANDIDATE: "Wilt u deze taak toewijzen?",
            TENTATIVELY_ASSIGN_CANDIDATE: "Wilt u deze taak voorlopig toewijzen?",
            REPEAT: "Wilt u deze service meer dan eens (herhalend/terugkerend)?",
            REPEAT_UNTIL: "Herhaal tot",
            REPEAT_EVERY: "Herhaal elke",
            REPEAT_ON: "Herhalen aan",
            BOOKING_ADDRESS: "Reserveringsadres",
            ADDRESS_LINE2: "Adresregel 2",
            CITY: "Stad",
            STATE: "Staat/Provincie",
            ZIP_CODE: "Postcode",
            NUMBER_CHILDREN: "Voor hoeveel kinderen wordt gezorgd?",
            SELECT_JOB_CATEGORY: "Selecteer functiecategorie",
            SELECT_DATE: "Reserveringsdatum",
            SELECT_SERVICE: "Selecteer dienst",
            NUMBER_CANDIDATE: "Aantal {0} nodig",
            SELECT_STATUS: "Selecteer boekingsstatus",
            CHECK_EXISTING: "Controleer op bestaand",
            INVALID_BOOKING_DURATION: "Reservering moet minimaal {0} uur zijn"
        },
        OPTIONS: {
            REPEAT_TYPE: ["Dagen", "Weken"],
            REPEAT_ON: [
                "Maandag",
                "Dinsdag",
                "woensdag",
                "Donderdag",
                "Vrijdag",
                "Zaterdag",
                "zondag"
            ]
        }
    },
    MENU_BAR: {
        TOP: {
            MESSAGES: "Berichten",
            SMS: "SMS",
            JOBS: "Vacatures",
            LOGOUT: "Uitloggen",
            DASHBOARD: "Mijn dashboard"
        },
        ADMIN: {
            USERS: {
                ROOT: "Gebruikers",
                CLIENTS: "Klanten",
                CANDIDATES: "Kandidaten",
                ADMINISTRATORS: "Beheerders"
            },
            JOBS_EVENTS: {
                ROOT: "Vacatures en agenda",
                SHIFT_JOB_CALENDAR: "Shift Job Kalender",
                PLACEMENT_JOBS: "Vacatures plaatsen",
                PERSONAL_TO_DO: "Persoonlijke taak"

            },
            TEMPLATES: {
                ROOT: "Sjablonen",
                EMAIL: "E-mailsjablonen",
                SMS: "SMS-sjablonen",
                DOCUMENT: "Documentsjablonen",
                NOTE: "Notitiesjablonen",
                PROFILE: "Profielsjablonen",
            },
            SETTINGS: {
                ROOT: "Instellingen",
                AGENCY: "Instellingen Agentschap",
                ADMIN: "Beheerdersinstellingen"
            },
            BUILDERS: {
                ROOT: "Bouwers",
                PROFILE: "Profielbouwer",
                EVALUATION: "Evaluatie Builder"
            },
            LOGS: {
                ROOT: "Logboeken",
                COMMUNICATION_LOG: "Communicatielogboek",
                STATUS_CHANGES: "Statuswijzigingen",
                ACTIVITY_LOG: "Activiteitenlogboek",
                PAYMENT_LOG: "Betalingslogboek",
                USER_MESSAGES_LOG: "Logboek gebruikersberichten",
            },
            OTHERS: {
                ROOT: "Anderen",
                RESOURCE_MANAGER: "Bronnenbeheer",
                REFERENCES: "Referenties",
                DOCUMENTS: "Documenten",
                EMAIL_BLASTER: "E-mailblaster",
                NOTIFICATION_CENTER: "Meldingscentrum",
                SNAPSHOT: "Momentopname",
                COMMUNITY: "Gemeenschap"
            }

        },
        CANDIDATES: {
            MY_PROFILE: "Mijn profiel",
            AVAILABLE_JOBS: "Beschikbare banen",
            MY_SCHEDULE: "Mijn schema",
            MY_JOBS: "Mijn banen",
            MY_FAMILIES: "Mijn gezinnen"
        },
    },
    NAV_BAR: {
        TOP: "Bovenste",
        CHECKLIST: "Checklist",
        DOCUMENTS: "Documenten",
        PHOTO_GALARY: "Fotogalerij",
        INTRODUCTION_VIDEO: "Introductievideo"
    },
    ENGINEHOW: {
        PROFILE_BUILDER: {
            BASIC: "Basisprincipes voor het maken van profielen",
            REQUIRE_FIELD: "Hoe kan ik vragen/veld markeren als verplicht of niet",
            NOTIFICATION_DESTINATION: "Bewerken wie op de hoogte wordt gesteld van nieuwe kandidaten"
        },
        EVALUATION_BUILDER: {
            GETTING_STARTED: "Aan de slag met evaluaties"
        },
        EMAIL_TEMPLATES: {
            GETTING_STARTED: "Aan de slag met e-mailsjablonen",
            DEFAULT_EMAIL_FOOTER: "Uw standaard e-mailvoettekst instellen"
        },
        DOCUMENT_TEMPLATES: {
            GETTING_STARTED: "Aan de slag met documentsjablonen",
            NOTIFICATION_WHEN_SIGNED: "Notificatie toevoegen wanneer document is ondertekend",
            ADD_DOCUMENT: "Handmatig een document toevoegen aan een gebruiker"
        },
        AGENTSCHAP: {
            STATUSES_CHECKLISTS_TYPES: "Uw proces in kaart brengen via statussen, checklists en typen",
            AGENCY_BRANDING_SETUP: "Branding instellen voor bureaus (logo, kleuren, lettertypen)",
            PROFILE_COMPLETE_SETUP: `Hoe een "Mijn profiel is voltooid"-knop toevoegen Kandidaten kunnen klikken om u te laten weten dat ze hun profiel hebben voltooid`,
            CONFIGURE_MULTIPLE_LOCATIONS: "Configureer uw bureau om meerdere verschillende locaties te bedienen"
        },
        EMAIL_BLASTER: {
            HOW_TO: "Hoe e-mailexplosies werken"
        },
        CLIENTS:{
            SHARE_CANDIDATE_PROFILE: "Het profiel van een kandidaat delen met een klant"
        }
    },
    ADMIN_DASHBOARD: {
        WELCOME_HEADER: "Welkom bij {0} Mission Control",
        PRO_TIP: {
            HEADER: "Bekijk wat er nieuw is:",
            TEXT: "Bulkploeg uitzenden!"
        },
        PLACE_HOLDERS: {
            ORDER_CLIENTS_BY: "Klanten bestellen door",
            ORDER_CANDIDATES_BY: "Bestel kandidaten op"
        },
        BUTTONS: {
            ADD_CLIENT: "Klant toevoegen",
            ADD_CANDIDATE: "Kandidaat toevoegen",
        },
    },
    ADD_USER_DIALOG: {
        HEADER: "Nieuwe gebruiker toevoegen",
        DESCRIPTION: `Dit is een mechanisme om handmatig een gebruiker aan uw database toe te voegen. Een gebruiker
        toegevoegd op deze manier wordt in de status "Pre-aanvraag" geplaatst
        (wat betekent dat ze nog geen aanvraagformulier hebben ingevuld). Een gebruiker in
        deze status kan nog steeds worden verzonden om het aanvraagformulier in te vullen. als jij
        wil automatisch een e-mail sturen naar gebruikers die op deze manier zijn toegevoegd, jij
        kan een e-mailsjabloon toevoegen dat een "Statuswijzigingsmelding" is
        triggering bij een wijziging in "Pre Application".`,
        LABELS: {
            EMAIL: "E-mail",
            PHONE: "Telefoonnummer",
            FIRST_NAME: "Voornaam",
            LAST_NAME: "Achternaam",
            PROFILE_BUILDER: "Profielbouwer",
            USER_TYPES: "Gebruikerstypen",
            LOCATIONS: "Locaties",
        }
    },
    STRIPE: {
        CONNECTED_SUCCESS: "Je account is succesvol gekoppeld aan Stripe.",
        FAILED_TO_CONECT: "Er is een probleem opgetreden bij het verbinden van je account met Stripe, probeer het opnieuw of neem contact op met Enginehire.",
        MISSING_INFO: "Je account is gekoppeld, maar er ontbreekt informatie over de Stripe-applicatie, klik op de knop Verbinden met stripe om verder te gaan waar je was gebleven",
    },
    DATA_TABLE: {
        SHOW: "Toon",
        ITEMS_PER_PAGE: "items per pagina",
        SHOWING_RANGE: "Toon {0} tot {1} van {2} items"
    },
    EMPLOYER_DIALOG: {
        TABS: {
            ADMIN: "Beheerder",
            PROFILE: "Profiel",
            INTAKE_NOTES: "Intake-aantekeningen",
            COMMUNICATION_LOG: "Communicatielogboek",
            RECORDS: "Records",
            INTAKE_NOTES_MOBILE: "Opmerkingen",
            COMMUNICATION_LOG_MOBILE: "Com-logboek"
        },
        INTERVIEW_TABS: {
            PROFILE: "Profiel",
            NOTES: "Opmerkingen"
        },
        BUTTONS: {
            DELETE_CLIENT: "Client verwijderen"
        },
    },
    CANDIDATE_DIALOG: {
        TABS: {
            ADMIN: "Beheerder",
            PROFILE: "Profiel",
            INTERVIEW: "Interview",
            COMMUNICATION_LOG: "Communicatielogboek",
            RECORDS: "Records",
            COMMUNICATION_LOG_MOBILE: "Com-logboek"
        },
        INTERVIEW_TABS: {
            PROFILE: "Profiel",
            INTERVIEW: "Interview"
        },
        BUTTONS: {
            DELETE_CANDIDATE: "Kandidaat verwijderen"
        }
    },
    ADMIN_PANEL: {
        TYPES: {
            TITLE: "Soorten",
            BUTTON: "Typen opslaan"
        },
        CHECKLIST: {
            TITLE: "Checklist",
            BUTTON: "Checklist opslaan"
        },
        TAGS: {
            TITLE: "Tagbeheer",
            BUTTON: "Tags opslaan"
        },
        LOCATIONS: {
            TITLE: "Locaties",
            BUTTON: "Locaties opslaan"
        },
        LANGUAGE: {
            TITLE: "Taal",
            BUTTON: "Taal opslaan"
        },
        SET_PROFILE_BUILDER: {
            TITLE: "Profieltype",
            BUTTON: "Profielbouwer bijwerken"
        },
        NOTES: {
            TITLE: "Opmerkingen",
            DESCRIPTION: "De hier gemaakte notities zijn alleen voor intern gebruik door beheerders, niet zichtbaar voor gebruikers.",
            BUTTON: "Notitie toevoegen"
        },
        EMAIL: {
            TITLE: "E-mail verzenden",
            BUTTON_SEND: "Verzenden",
            BUTTON_LOAD: "Laden",
            SELECT_TEMPLATE: "Sjabloon selecteren",
            FROM_EMAIL: "Van e-mail"
        },
        SMS: {
            TITLE: "Sms versturen",
            BUTTON: "Verzenden"
        },
        RESET_PASSWORD: {
            DESCRIPTION: "U kunt hier handmatig het wachtwoord van de gebruiker opnieuw instellen",
            BUTTON: "Wachtwoord bijwerken"
        },
        EVENT: {
            TITLE: "Evenement plannen (interview, vergadering, enz.)",
            DESCRIPTION: "Deze gebeurtenissen verschijnen in het gebruikersdashboard.",
            EVENT_TITLE: "Evenementtitel",
            EVENT_DATE: "Gebeurtenisdatum",
            EVENT_TIME: "Gebeurtenistijd",
            INTERVIEW_LINK: "Interviewlink",
            INTERVIEW_LINK_PLACE_HOLDER: "Zoomlink of andere bellink",
            NOTES: "Opmerkingen",
            STATUS_UPDATE_TO: "Status om gebruiker bij te werken naar",
            SEND_EMAIL_NOTIFICATION: "Stuur een e-mailmelding van het geplande evenement",
            ADD_TO_CALENDAR: "Toevoegen aan persoonlijke takenagenda",
            BUTTON: "Evenement plannen"
        },
        CREDIT: {
            TITLE: "Tegoeden",
            BUTTON_ADD: "Tegoed toevoegen",
            BUTTON_EDIT: "Bewerken",
            EDIT_CREDIT_TITLE: "Tegoed bewerken",
            PLACE_HOLDERS: {
                VALUE: "Waarde",
                NOTES: "Opmerkingen"
            }
        },
        STRIPE: {
            BILL_CLIENT: "Je kunt klanten hier handmatig factureren via Stripe",
            SEND_INVOICE: "Je kunt hier handmatig Stripe-facturen verzenden",
            BUTTON_CHARGE: "Opladen via streep",
            BUTTON_RESET: "Reset streepinformatie",
            BUTTON_INVOICE: "Factuur via streep",
            PAYMENT_LOGS: "Betalingslogboeken"
        },
        AUTHORIZE_NET: {
            BILL_CLIENT: "Je kunt klanten hier handmatig factureren via Authorize.Net",
            SEND_INVOICE: "U kunt hier handmatig Authorize.Net-facturen verzenden",
            BUTTON_CHARGE: "Opladen via Authorize.Net",
            BUTTON_RESET: "Reset Authorize.Net-informatie",
            BUTTON_INVOICE: "Factuur via Authorize.Net",
            PAYMENT_LOGS: "Betalingslogboeken"
        },
        REVIEW: {
            TITLE: "Recensies",
            RATING: "Beoordeling",
            AVERAGE_RATING: "Gemiddelde beoordeling",
            NO_DATA: "Nog geen beoordelingen."
        },
        ADD_DOCUMENT: {
            TITLE: "Document toevoegen",
            DESCRIPTION: `Je kunt hier elk documentsjabloon aan de gebruiker toevoegen, selecteer er gewoon een
            van uw documenten uit de vervolgkeuzelijst:`,
            BUTTON: "Document toevoegen",
        },
        ADD_EVALUATIE: {
            BUTTON: "Evaluatie toevoegen",
        },
        RELATIONSHIP: {
            CANDIDATE: {
                TITLE: "Toegewezen kandidaten",
                NO_CANDIDATE: "Er zijn geen kandidaten gekoppeld aan deze klant."
            },
            CLIENT: {
                TITLE: "Toegewezen klanten",
                NO_CLIENT: "Er zijn geen klanten gelinkt aan deze kandidaat."
            },
            ADD_CANDIDATE: "Kandidaat toevoegen"
        },
        LAST_CONTACTED_DATE: "Laatste contactdatum",
        CANDIDATE_BADGES: {
            TITLE: "Kandidaatbadges",
            BUTTON: "Badges opslaan"
        }
    },
    COMMUNICATIE: {
        DATE: "Datum",
        FROM: "Van",
        TO: "Aan",
        SUBJECT: "Onderwerp",
        MESSAGE: "Bericht",
        RE_SEND: "Opnieuw verzenden"
    },
    PLACEMENT_JOB: {
        SEARCH_TEXT: "Zoeken op functietitel, functie-ID, planning, stad, staat of beschrijving",
        JOB_HIDEN_DESCRIPTION: `Vacatures met de status "Concept", "Gesloten" of "Gevuld" verschijnen niet op de taak
        board standaard. Om de status van een vacature bij te werken, klikt u op "Vacature bewerken".`,
        CLIENT_POSTING_JOB_DESCRIPTION: "Dit is voor het plaatsen van langere termijn posities voor deze klant.",
    },
    CONFIRM_DIALOGS: CONFIRM_DIALOGS,
    ERROR_DIALOGS: ERROR_DIALOGS,
    RESULT_DIALOGS: RESULT_DIALOGS,
    AGENCY_SETTINGS: AGENCY_SETTINGS
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/nl.js